import { createContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";

export const ConnContext = createContext();
export const ConnProvider = ({ children }) => {
  const [AtmId, setAtmID] = useState([]);
  const { user } = useSelector((state) => state.auth);

  const [payloadData, setPayloadData] = useState({
    username: user?.data?.username,
    name: "",
    emailId: "",
    address1: "",
    address2: "",
    address3: "",
    city: "",
    // documents: "",
    state: "",
    pinCode: "",
    firstContactPersonName: "",
    firstContactPersonMobileNo: "",
    // secondContactPersonName: '',
    // secondContactPersonMobileNo: '',
    bankName: "",
    accountNo: "",
    ifscCode: "",
    rate: "",
    waMarketingRate: "",
    waUtilityRate: "",
    waAuthenticationRate: "",
    rcsRate: "",
    waServices: false,
    gstCertificate: null,
    incorporationCertificate: null,
    aadharFront: null,
    aadharBack: null,
    panTan: null,
    authPersonPan: null,
    boardResolution: null,
  });

  return (
    <ConnContext.Provider
      value={{
        AtmId,
        payloadData,
        setPayloadData,
      }}
    >
      {children}
    </ConnContext.Provider>
  );
};
